module.exports = __webpack_public_path__ + "static/img/miPad1.b97a3a55.png";